import { compose, withProps } from 'recompose'
import MakeAppointmentButton from './MakeAppointmentButton'
import withRequestApptClick from 'components/common/hoc/withRequestApptClick'

export default compose(
  withProps(() => ({ navigateToQuickApptPage: true })),
  withRequestApptClick
)(MakeAppointmentButton)
